/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs */

const en_admin_external_booking_edit_order_summary_pick_resource_for_price = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a resource to see the price.`)
};

const de_admin_external_booking_edit_order_summary_pick_resource_for_price = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine Ressource, um den Preis zu sehen.`)
};

const es_admin_external_booking_edit_order_summary_pick_resource_for_price = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un recurso para ver el precio.`)
};

const fr_admin_external_booking_edit_order_summary_pick_resource_for_price = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une ressource pour voir le prix.`)
};

const nl_admin_external_booking_edit_order_summary_pick_resource_for_price = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een voorziening om de prijs te zien.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */
const it_admin_external_booking_edit_order_summary_pick_resource_for_price = en_admin_external_booking_edit_order_summary_pick_resource_for_price;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_order_summary_pick_resource_for_price = en_admin_external_booking_edit_order_summary_pick_resource_for_price;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */
const pl_admin_external_booking_edit_order_summary_pick_resource_for_price = en_admin_external_booking_edit_order_summary_pick_resource_for_price;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */
const hu_admin_external_booking_edit_order_summary_pick_resource_for_price = en_admin_external_booking_edit_order_summary_pick_resource_for_price;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs) => LocalizedString} */
const ro_admin_external_booking_edit_order_summary_pick_resource_for_price = en_admin_external_booking_edit_order_summary_pick_resource_for_price;

/**
* | output |
* | --- |
* | "Pick a resource to see the price." |
*
* @param {Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_pick_resource_for_price = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_Pick_Resource_For_PriceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
	return ro_admin_external_booking_edit_order_summary_pick_resource_for_price(inputs)
});
export { admin_external_booking_edit_order_summary_pick_resource_for_price as "admin.external_booking_edit.order_summary.pick_resource_for_price" }